'use strict';

var isDefinedAndNotNull = require('../lang/is-defined-and-not-null');

/**
 * Estensione per controllare se un elemento del DOM ha un determinato attributo dichiarato
 *
 * @param name
 * @param $el
 * @returns {boolean}
 */
module.exports = function hasAttr(name, $el) {
    var value = $el.attr(name);

    return isDefinedAndNotNull(value) && value !== false && value !== 'undefined';
};
